module.exports = __webpack_public_path__ + "static/media/AdvancedEquipment.53b7b41f.png";